document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.getElementById('MobileNav');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      toggle.setAttribute('aria-label', open ? 'Open menu' : 'Close menu');
      nav.hidden = open;
    });
  }

  const gallery = document.querySelector('.product-gallery');
  if (gallery) {
    const main = gallery.querySelector('[data-gallery-main]');
    const next = gallery.querySelector('[data-gallery-next]');
    const prev = gallery.querySelector('[data-gallery-prev]');
    const image = main?.querySelector('img');
    const items = [...gallery.querySelectorAll('[data-gallery-item]')];
    const counter = gallery.querySelector('[data-gallery-count]');
    const progress = gallery.querySelector('[data-gallery-progress]');
    const dots = [...gallery.querySelectorAll('[data-gallery-dot]')];
    let active = Math.max(0, items.findIndex(item => item.dataset.initial === 'true'));
    const showImage = index => {
      if (!image || !items[index]) return;
      active = index;
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = items[index].dataset.image;
      image.alt = items[index].dataset.alt || '';
      if (counter) counter.textContent = `${String(index + 1).padStart(2, '0')} / ${String(items.length).padStart(2, '0')}`;
      if (progress) progress.style.width = `${((index + 1) / items.length) * 100}%`;
      dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
    };
    if (items.length > 1) {
      if (counter) counter.textContent = `${String(active + 1).padStart(2, '0')} / ${String(items.length).padStart(2, '0')}`;
      if (progress) progress.style.width = `${((active + 1) / items.length) * 100}%`;
      next?.addEventListener('click', () => showImage((active + 1) % items.length));
      prev?.addEventListener('click', () => showImage((active - 1 + items.length) % items.length));
      dots.forEach(dot => dot.addEventListener('click', () => showImage(Number(dot.dataset.galleryDot))));
      let touchStartX = 0;
      let touchStartY = 0;
      main?.addEventListener('touchstart', event => {
        touchStartX = event.changedTouches[0].clientX;
        touchStartY = event.changedTouches[0].clientY;
      }, { passive: true });
      main?.addEventListener('touchend', event => {
        const deltaX = event.changedTouches[0].clientX - touchStartX;
        const deltaY = event.changedTouches[0].clientY - touchStartY;
        if (Math.abs(deltaX) > 45 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2) {
          showImage((active + (deltaX < 0 ? 1 : items.length - 1)) % items.length);
        }
      }, { passive: true });
    }
  }

  const selector = document.querySelector('[data-variant-select]');
  const purchaseOptions = document.querySelector('[data-purchase-options]');
  const sellingPlanInput = document.querySelector('[data-selling-plan-input]');
  const priceMain = document.querySelector('[data-price-main]');
  const priceCompare = document.querySelector('[data-price-compare]');
  const stickyPrice = document.querySelector('[data-sticky-price]');
  const add = document.querySelector('[data-add-button]');
  const sticky = document.querySelector('[data-sticky-button]');
  const updatePrice = (amount, compare) => {
    if (priceMain) priceMain.textContent = amount || '';
    if (stickyPrice) stickyPrice.textContent = amount || '';
    if (priceCompare) {
      priceCompare.textContent = compare || '';
      priceCompare.hidden = !compare;
    }
  };
  const syncPlan = () => {
    const currentId = selector ? selector.value : document.querySelector('[data-purchase-panel]')?.dataset.purchasePanel;
    const panel = [...document.querySelectorAll('[data-purchase-panel]')].find(el => el.dataset.purchasePanel === currentId);
    document.querySelectorAll('[data-purchase-panel]').forEach(el => { el.hidden = el !== panel; });
    if (purchaseOptions) purchaseOptions.hidden = !panel;
    const subscriptionRadio = panel?.querySelector('[data-subscription-radio]');
    const schedule = panel?.querySelector('[data-plan-frequency]');
    const scheduleOption = schedule?.selectedOptions[0];
    if (subscriptionRadio && scheduleOption) {
      subscriptionRadio.value = scheduleOption.value;
      subscriptionRadio.dataset.price = scheduleOption.dataset.price || '';
      subscriptionRadio.dataset.comparePrice = scheduleOption.dataset.comparePrice || '';
      const subscriptionPrice = panel.querySelector('[data-subscription-price]');
      if (subscriptionPrice) subscriptionPrice.textContent = scheduleOption.dataset.price || '';
    }
    const chosen = panel?.querySelector('[data-plan-option]:checked') || panel?.querySelector('[data-plan-option]');
    if (chosen) chosen.checked = true;
    const subscriptionChoice = panel?.querySelector('[data-subscription-choice]');
    if (subscriptionChoice) subscriptionChoice.dataset.selected = String(chosen === subscriptionRadio);
    if (sellingPlanInput) sellingPlanInput.value = chosen?.value || '';
    const option = selector?.selectedOptions[0];
    updatePrice(chosen?.dataset.price || option?.dataset.price || priceMain?.textContent, chosen ? chosen.dataset.comparePrice : (option?.dataset.comparePrice || ''));
  };
  document.querySelectorAll('[data-plan-option]').forEach(radio => radio.addEventListener('change', syncPlan));
  document.querySelectorAll('[data-plan-frequency]').forEach(select => select.addEventListener('change', () => {
    const radio = select.closest('[data-purchase-panel]')?.querySelector('[data-subscription-radio]');
    if (radio) radio.checked = true;
    syncPlan();
  }));
  if (selector) {
    selector.addEventListener('change', () => {
      const option = selector.selectedOptions[0];
      const available = option.dataset.available === 'true';
      if (add) { add.disabled = !available; add.textContent = available ? 'Add to bag' : 'Sold out'; }
      if (sticky) { sticky.disabled = !available; sticky.textContent = available ? 'Add to bag' : 'Sold out'; }
      syncPlan();
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      url.searchParams.delete('selling_plan');
      history.replaceState({}, '', url);
    });
  }
  if (purchaseOptions) syncPlan();
  if (sticky) sticky.addEventListener('click', () => {
    const button = document.querySelector('[data-product-form] [data-add-button]');
    if (button && !button.disabled) button.click();
  });

  const cartRoot = window.Shopify?.routes?.root || '/';
  let drawer = document.querySelector('[data-cart-drawer]');
  let drawerPreviousFocus = null;
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.hidden = true;
    document.body.classList.remove('cart-drawer-open');
    drawerPreviousFocus?.focus?.();
  };
  const showDrawer = () => {
    if (!drawer) return;
    if (!document.body.classList.contains('cart-drawer-open')) drawerPreviousFocus = document.activeElement;
    drawer.hidden = false;
    document.body.classList.add('cart-drawer-open');
    drawer.querySelector('[data-cart-close].cart-drawer-close')?.focus();
  };
  const refreshDrawer = async () => {
    const response = await fetch(cartRoot + '?section_id=cart-drawer', { headers: { 'Accept': 'text/html' } });
    if (!response.ok) throw new Error('Unable to update the bag');
    const html = await response.text();
    const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer]');
    if (!next || !drawer) throw new Error('Unable to show the bag');
    drawer.replaceWith(next);
    drawer = next;
    const cartResponse = await fetch(cartRoot + 'cart.js');
    if (cartResponse.ok) {
      const cart = await cartResponse.json();
      document.querySelectorAll('[data-cart-count]').forEach(count => {
        count.textContent = String(cart.item_count);
        count.hidden = cart.item_count === 0;
      });
      document.querySelectorAll('[data-cart-open]').forEach(link => link.setAttribute('aria-label', `Cart, ${cart.item_count} items`));
    }
  };
  const addItems = async items => {
    const response = await fetch(cartRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || 'Unable to add those items');
    try { await refreshDrawer(); showDrawer(); }
    catch (_) { window.location.assign(cartRoot + 'cart'); }
  };
  window.EssentiqueCart = { addItems, open: async () => { await refreshDrawer(); showDrawer(); } };
  const bundle = document.querySelector('[data-bundle-builder]');
  if (bundle) {
    let currentStep = 1;
    const picked = type => bundle.querySelector(`input[name="bundle_${type}"]:checked`);
    const showStep = step => {
      currentStep = step;
      bundle.querySelectorAll('[data-bundle-step]').forEach(panel => { panel.hidden = Number(panel.dataset.bundleStep) !== step; });
      bundle.querySelectorAll('[data-bundle-label]').forEach(label => label.classList.toggle('is-current', Number(label.dataset.bundleLabel) === step));
      if (step === 3) {
        bundle.querySelector('[data-bundle-diffuser-name]').textContent = picked('diffuser')?.dataset.title || '';
        bundle.querySelector('[data-bundle-oil-name]').textContent = picked('oil')?.dataset.title || '';
      }
      bundle.querySelector('.bundle-steps')?.scrollIntoView({ block: 'start', behavior: 'smooth' });
    };
    bundle.querySelectorAll('[data-bundle-next]').forEach(button => button.addEventListener('click', () => {
      const type = currentStep === 1 ? 'diffuser' : 'oil';
      const panel = bundle.querySelector(`[data-bundle-step="${currentStep}"]`);
      if (!picked(type)) { panel.querySelector('.bundle-option input')?.focus(); return; }
      showStep(currentStep + 1);
    }));
    bundle.querySelectorAll('[data-bundle-back]').forEach(button => button.addEventListener('click', () => showStep(Math.max(1, currentStep - 1))));
    bundle.querySelector('[data-bundle-add]')?.addEventListener('click', async event => {
      const button = event.currentTarget;
      const error = bundle.querySelector('[data-bundle-error]');
      error.hidden = true;
      button.disabled = true;
      try {
        await addItems([{ id: picked('diffuser').value, quantity: 1 }, { id: picked('oil').value, quantity: 1 }]);
      } catch (err) {
        error.textContent = err.message || 'Unable to add this pairing right now.';
        error.hidden = false;
      } finally { button.disabled = false; }
    });
  }
  document.addEventListener('click', async event => {
    const openLink = event.target.closest('[data-cart-open]');
    if (openLink && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0) {
      event.preventDefault();
      try { await refreshDrawer(); showDrawer(); } catch (_) { window.location.assign(openLink.href); }
      return;
    }
    if (event.target.closest('[data-cart-close]')) { closeDrawer(); return; }
    const change = event.target.closest('[data-cart-change]');
    if (!change) return;
    change.disabled = true;
    try {
      const response = await fetch(cartRoot + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: change.dataset.key, quantity: Number(change.dataset.quantity) })
      });
      if (!response.ok) throw new Error('Unable to update the bag');
      await refreshDrawer();
      showDrawer();
    } catch (_) { window.location.assign(cartRoot + 'cart'); }
  });
  document.addEventListener('keydown', event => {
    if (!drawer || drawer.hidden) return;
    if (event.key === 'Escape') { closeDrawer(); return; }
    if (event.key !== 'Tab') return;
    const focusable = [...drawer.querySelectorAll('button:not([disabled]), a[href]')].filter(el => el.offsetParent !== null);
    if (!focusable.length) return;
    if (event.shiftKey && document.activeElement === focusable[0]) { event.preventDefault(); focusable[focusable.length - 1].focus(); }
    else if (!event.shiftKey && document.activeElement === focusable[focusable.length - 1]) { event.preventDefault(); focusable[0].focus(); }
  });
  const productForm = document.getElementById('ProductForm');
  productForm?.addEventListener('submit', async event => {
    if (!window.fetch || !drawer) return;
    event.preventDefault();
    const form = event.currentTarget;
    const error = document.querySelector('[data-product-error]');
    const button = form.querySelector('[data-add-button]');
    const data = new FormData(form);
    if (!data.get('selling_plan')) data.delete('selling_plan');
    if (error) { error.hidden = true; error.textContent = ''; }
    if (button) button.disabled = true;
    try {
      const response = await fetch(cartRoot + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this item');
      try { await refreshDrawer(); showDrawer(); }
      catch (_) { window.location.assign(cartRoot + 'cart'); }
    } catch (err) {
      if (error) { error.textContent = err.message || 'Please try again.'; error.hidden = false; }
    } finally { if (button) button.disabled = false; }
  });

  const cartForm = document.getElementById('CartForm');
  if (cartForm) {
    const updateButton = cartForm.querySelector('[data-cart-update-submit]');
    let updateTimer;
    const updateCart = () => {
      if (!cartForm.reportValidity()) return;
      if (cartForm.requestSubmit) cartForm.requestSubmit(updateButton);
      else updateButton.click();
    };
    cartForm.querySelectorAll('[data-quantity-step]').forEach(button => button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('input[name="updates[]"]');
      const current = Number.parseInt(input.value, 10);
      const quantity = Math.max(0, (Number.isNaN(current) ? Number(input.dataset.current) : current) + Number(button.dataset.quantityStep));
      if (quantity === current) return;
      input.value = String(quantity);
      window.clearTimeout(updateTimer);
      updateCart();
    }));
    cartForm.querySelectorAll('input[name="updates[]"]').forEach(input => {
      input.addEventListener('input', () => {
        window.clearTimeout(updateTimer);
        if (input.value !== '' && input.validity.valid) updateTimer = window.setTimeout(updateCart, 900);
      });
      input.addEventListener('keydown', event => {
        if (event.key === 'Enter') { event.preventDefault(); window.clearTimeout(updateTimer); updateCart(); }
      });
    });
    cartForm.addEventListener('submit', () => window.clearTimeout(updateTimer));
  }

  const offer = document.querySelector('[data-email-offer]');
  if (offer && !window.Shopify?.designMode) {
    const dialog = offer.querySelector('.email-offer-dialog');
    let previousFocus;
    let expires = 0;
    try { expires = Number(localStorage.getItem('essentiqueOfferDismissedUntil') || 0); } catch (_) {}
    const show = () => {
      previousFocus = document.activeElement;
      offer.hidden = false;
      document.body.classList.add('offer-open');
      dialog?.focus();
    };
    const close = () => {
      offer.hidden = true;
      document.body.classList.remove('offer-open');
      const days = offer.querySelector('.offer-success') ? 30 : 7;
      try { localStorage.setItem('essentiqueOfferDismissedUntil', String(Date.now() + days * 86400000)); } catch (_) {}
      previousFocus?.focus?.();
    };
    offer.querySelectorAll('[data-offer-close]').forEach(button => button.addEventListener('click', close));
    dialog?.addEventListener('keydown', event => {
      if (event.key === 'Escape') { close(); return; }
      if (event.key !== 'Tab') return;
      const items = [...dialog.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href]')];
      const first = items[0], last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    const returnedToOffer = window.location.hash === '#EmailOfferForm';
    if (returnedToOffer && offer.querySelector('.offer-success, .offer-error')) show();
    else if (Date.now() >= expires && !window.location.hash.includes('Footer')) {
      window.setTimeout(show, Math.max(0, Number(offer.dataset.delay || 10)) * 1000);
    }
  }
});
